export default __webpack_public_path__ + "static/media/iud_info_background.1a1e48a5.jpg";